import { useSelector } from 'react-redux';
import { GALLERY_ASSET_TAG_CODE } from './constants';


const useGalleryAssetTags = (assetTagCode: string = GALLERY_ASSET_TAG_CODE) => {
  const {
    assetCategoryTags,
    currentCategoryId,
    assetImagesData,
    uploadingPrivateImage
  } = useSelector((state: IReduxState) => state.asset_manager);

  const {profile: {stores = []}} = useSelector((state: IReduxState) => state.user);

  const storeCode = stores.length && stores[0]?.storeCode;
  const assetTag = assetCategoryTags.find((tag) => tag.tagCode === assetTagCode);
  const privateTag = assetCategoryTags.find((tag) => tag.tagCode === 'private');
  const storeCodeTag = assetCategoryTags.find((tag) => tag.tagCode === `${storeCode}`);

  const ownImagesTagIds = (assetTag && privateTag && storeCodeTag)
    ? `${assetTag.id}, ${privateTag.id}, ${storeCodeTag.id}`
    : '';

  return {
    assetTag,
    privateTag,
    storeCodeTag,
    ownImagesTagIds,
    currentCategoryId,
    storeCode,
    assetImagesData,
    uploadingPrivateImage
  };
};

export default useGalleryAssetTags;
